import React, { useState, useEffect } from "react";
import WithdrawRequest from "./WithdrawRequest";
import WithdrawHistoryTable from "../components/transactions/WithdrawHistoryTable";
import DepositHistoryTable from "../components/transactions/DepositHistoryTable";
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../firebase";

export default function TransactionsPage({ user, balance }) {
  const [tab, setTab] = useState("Withdrawals");
  const [withdrawals, setWithdrawals] = useState([]);
  const [deposits, setDeposits] = useState([]);

  useEffect(() => {
    if (!user) return;
    const q = query(
      collection(db, "withdraw_requests"),
      where("userId", "==", user.uid),
      orderBy("requestedAt", "desc")
    );
    return onSnapshot(q, (snap) => {
      setWithdrawals(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });
  }, [user]);

  // Deposits
  useEffect(() => {
    if (!user) return;
    const q = query(
      collection(db, "deposits"),
      where("userId", "==", user.uid),
      orderBy("timestamp", "desc")
    );
    return onSnapshot(q, (snap) => {
      const data = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      // console.log("Fetched deposits:", data); // 👈 SEE YOUR DATA HERE
      setDeposits(data);
    });
  }, [user]);

  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-[#101c2e] to-[#142231] px-2 md:px-0 py-10 flex flex-col items-center md:mt-14">
      {/* Withdraw Funds Form */}
      <div className="w-full max-w-md mb-8">
        <div className="bg-[#1b2538] p-7 rounded-2xl shadow-lg">
          <WithdrawRequest user={user} balance={balance} />
        </div>
      </div>

      {/* Tabs */}
      <div className="w-full max-w-3xl mb-6 flex gap-2">
        <button
          className={`flex-1 py-3 text-lg font-bold rounded-2xl transition ${
            tab === "Withdrawals"
              ? "bg-lime-400 text-slate-900 shadow-lg"
              : "bg-slate-900 text-lime-300"
          }`}
          onClick={() => setTab("Withdrawals")}
        >
          Withdrawals
        </button>
        <button
          className={`flex-1 py-3 text-lg font-bold rounded-2xl transition ${
            tab === "Deposits"
              ? "bg-lime-400 text-slate-900 shadow-lg"
              : "bg-slate-900 text-lime-300"
          }`}
          onClick={() => setTab("Deposits")}
        >
          Deposits
        </button>
      </div>

      {/* Main Content (Tables) */}
      <div className="w-full max-w-3xl">
        {tab === "Withdrawals" && (
          <>
            <h3 className="text-2xl font-bold text-lime-300 mb-4">
              Withdrawal History
            </h3>
            <div className="bg-[#232b3d] rounded-2xl p-3 md:p-6 shadow-xl">
              <WithdrawHistoryTable withdrawals={withdrawals} user={user} />
            </div>
          </>
        )}

        {tab === "Deposits" && (
          <>
            <h3 className="text-2xl font-bold text-lime-300 mb-4">
              Deposit History
            </h3>
            <div className="bg-[#232b3d] rounded-2xl p-3 md:p-6 shadow-xl">
              <DepositHistoryTable deposits={deposits} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
